import { Component, OnInit, Input } from '@angular/core';
import { Announcer } from "../../models/announcer.model";

declare var require: any

@Component({
    selector: 'announcer',
    templateUrl: './announcer.component.html',
    styleUrls: ['../../app.component.css']
})

export class AnnouncerComponent implements OnInit {
    @Input() model: Announcer;
    public imgData: string;

    constructor() {

    }

    ngOnInit(): void {
        if (!this.model) {
            throw new Error("model is null");
        }
        if (!this.model.boxes) {
            this.model.boxes = []
        }
        if (!this.model.gif) {
            this.model.gif = require('../../../assets/images/animations/flowers3.gif');
        }
        if (this.model.backgroundUrl) {
            this.imgData = `url(${this.model.backgroundUrl})`;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/announcer/announcer.component.ts